// reset-store.js
import { toRaw } from 'vue'
import cloneDeep from 'lodash.clonedeep'

export default function resetStore({ store }) {
  const initialState = cloneDeep(toRaw(store.$state))
  store.$reset = () => store.$patch(cloneDeep(initialState))
}
